import api from '@/api'

const state = {
  lists: [],
  list: null
}

const actions = {
  async getLists ({commit}, listsData) {
    await api.getLists(listsData, lists => {
      commit('indexLists', lists)
    }, error => {
      console.log('could not pull the lists')
      console.log(error)
    })
  },
  async storeList ({commit}, listData) {
    await api.storeList(listData, list => {
      commit('createList', list)
    }, error => {
      console.log('could not add that new list')
      console.log(error)
    })
  },
  async submitClaimEmail ({commit}, data) {
    await api.claimList(data, list => {
      commit('updatedList', list)
    }, error => {
      console.log('could not claim that list')
      console.log(error)
    })
  },
  async addIdeaToList ({commit}, data) {
    await api.storeIdeaOnList(data, list => {
      commit('updatedList', list)
    }, error => {
      console.log('could not add that to list')
      console.log(error)
    })
  },
  async updateIdeaOnList ({commit}, data) {
    await api.updateIdeaOnList(data.listId, data.ideaId, data.data, list => {
      commit('updatedList', list)
    }, error => {
      console.log('could not update that on list')
      console.log(error)
    })
  },
  async updateIdeaSilently ({commit}, data) {
    await api.updateIdeaOnList(data.listId, data.ideaId, data.data, list => {
      
    }, error => {
      console.log('could not update that on list silently')
      console.log(error)
    })
  },
  async removeIdeaFromList ({commit}, data) {
    await api.deleteIdeaOnList(data, ideaId => {
      commit('removedIdeaFromList', ideaId)
    }, error => {
      console.log('could not remove that from list')
      console.log(error)
    })
  },
  async getList ({commit}, listsData) {
    await api.getList(listsData, lists => {
      commit('readList', lists)
    }, error => {
      console.log('could not pull the lists')
      console.log(error)
    })
  },
  async updateList ({commit}, listData) {
    await api.updateList(listData, list => {
      console.log('updated list', list)
      commit('updatedList', list)
    }, error => {
      console.log('could not update that list')
      console.log(error)
    })
  },
  async deleteList ({commit}, listId) {
    await api.deleteList(listId, response => {
      commit('removeList', listId)
    }, error => {
      console.log('could not delete that list')
      console.log(error)
    })
  },
  async resetList ({commit}, listId) {
    commit('didResetList', listId)
  }
}

const mutations = {
  indexLists (state, lists) {
    state.lists = lists
  },
  createList (state, list) {
    state.lists.unshift(list)
    state.list = list
  },
  readList (state, list) {
    state.list = list
  },
  updatedList (state, list) {
    state.lists = state.lists.filter(eachList => { return eachList._id !== list._id })
    state.lists.unshift(list)

    state.list = list
  },
  removedIdeaFromList (state, ideaId) {
    state.list.ideas = state.list.ideas.filter(i => { return i.id !== ideaId })
  },
  removeList (state, listId) {
    state.lists = state.lists.filter(eachList => { return eachList._id !== listId })

    state.list = null
  },
  didResetList (state, listId) {
    state.list = null
  }
}

const getters = {
  list (state) {
    return state.list
  },
  lists (state) {
    return state.lists
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/lists.js